import { Button } from '@calendly/ui/components/button';
import { ArrowDownIcon } from '@calendly/ui/components/icons';
import classNames from 'classnames';
import { forwardRef } from 'react';
const arrowUpIconCss = "a2mj9ae";
export const ArrowUpIcon = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(arrowUpIconCss, props.className)}>
      <ArrowDownIcon />
    </Component>;
});
const styledButtonCss = "s1mxh2oy";
export const StyledButton = forwardRef((props, ref) => <Button ref={ref} {...props} className={classNames(styledButtonCss, props.className)} />);

require("./styles.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");